var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherlinkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 10.271C27.1626 10.271 10.271 27.1626 10.271 47.9999C10.271 68.8372 27.1626 85.7288 47.9999 85.7288C68.8372 85.7288 85.7288 68.8372 85.7288 47.9999C85.7288 27.1626 68.8372 10.271 47.9999 10.271ZM47.9999 79.0506C30.8514 79.0506 16.9492 65.1492 16.9492 47.9999C16.9492 30.8506 30.8506 16.9492 47.9999 16.9492C65.1492 16.9492 79.0506 30.8506 79.0506 47.9999C79.0506 65.1492 65.1492 79.0506 47.9999 79.0506Z",
    fill: "url(#paint0_linear_4893_2217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7918 27.2524C36.3758 27.3644 27.1243 36.8222 27.2523 48.2382C27.2852 51.1573 27.9207 53.9315 29.0416 56.4426C29.2096 56.8186 29.7065 56.9022 29.9927 56.6071L34.567 51.8862C34.8656 51.5786 34.9883 51.1431 34.9012 50.7226C34.7198 49.8435 34.6247 48.9333 34.6247 48C34.6247 40.6115 40.6132 34.6231 47.999 34.6231C48.7545 34.6231 49.495 34.6853 50.2167 34.8062C50.6994 34.8871 51.1918 34.7342 51.5332 34.3822L56.0825 29.6889C56.3492 29.4142 56.2558 28.9546 55.9021 28.8089C53.4061 27.7804 50.6656 27.2231 47.791 27.2515L47.7918 27.2524Z",
    fill: "url(#paint1_linear_4893_2217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2055 68.7734C59.6215 68.6614 68.8731 59.2036 68.7451 47.7876C68.7122 44.8685 68.0766 42.0942 66.9558 39.5831C66.7878 39.2071 66.2909 39.1236 66.0046 39.4187L61.4304 44.1396C61.1318 44.4471 61.0091 44.8827 61.0962 45.3031C61.2775 46.1822 61.3726 47.0925 61.3726 48.0258C61.3726 55.4142 55.3842 61.4027 47.9984 61.4027C47.2429 61.4027 46.5024 61.3405 45.7807 61.2196C45.298 61.1387 44.8055 61.2916 44.4642 61.6436L39.9149 66.3369C39.6482 66.6116 39.7415 67.0711 40.0953 67.2169C42.5913 68.2454 45.3318 68.8027 48.2064 68.7743L48.2055 68.7734Z",
    fill: "url(#paint2_linear_4893_2217)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3102 52.1024L28.5968 60.8158C26.8285 62.5841 26.8284 65.4509 28.5965 67.219C30.3646 68.9872 33.2314 68.987 34.9997 67.2187L43.7132 58.5053C45.4815 56.737 45.4816 53.8702 43.7135 52.102C41.9454 50.3339 39.0785 50.3341 37.3102 52.1024Z",
    fill: "url(#paint3_linear_4893_2217)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8078 28.6575L52.0944 37.371C50.3261 39.1393 50.3259 42.0061 52.094 43.7742C53.8622 45.5423 56.729 45.5422 58.4973 43.7739L67.2107 35.0605C68.979 33.2922 68.9792 30.4253 67.211 28.6572C65.4429 26.8891 62.5761 26.8892 60.8078 28.6575Z",
    fill: "url(#paint4_linear_4893_2217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4893_2217",
    x1: 10.271,
    y1: 47.9999,
    x2: 115.603,
    y2: 47.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4893_2217",
    x1: 27.2514,
    y1: 42.0177,
    x2: 66.8772,
    y2: 42.0177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4893_2217",
    x1: 39.7611,
    y1: 54.0071,
    x2: 79.1718,
    y2: 54.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4893_2217",
    x1: 27.2704,
    y1: 59.6607,
    x2: 57.1575,
    y2: 59.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4893_2217",
    x1: 50.7678,
    y1: 36.2165,
    x2: 78.3429,
    y2: 36.2165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherlinkLogo);
export default __webpack_public_path__ + "static/media/etherlink-logo.6d5a45b83b2bcb14491c45b28812b6b3.svg";
export { ForwardRef as ReactComponent };